<template>
   <div class="contenedor_modal">
      <div class="contenedor_modal_cuerpo">
         <div class="contenedor_modal_cabecera">
            <b-button type="button" size="sm" variant="danger" v-shortkey="['esc']" @shortkey="cerrar"
               @click="cerrar"><i class="fas fa-times"></i></b-button>
         </div>

         <b-container fluid="">
            <b-row>
               <div class="col-sm-12 mt-3">
                  <h3>Acciones</h3>
               </div>
               <div class="col-sm-12 mt-3">
                  <button type="button" class="btn btn-sm btn-outline-dark btn-block"
                     @click="set_modulo('reporte_corte_caja')">
                     Corte de caja
                  </button>
               </div>
               <div class="col-sm-12 mt-3">
                  <button type="button" class="btn btn-sm btn-outline-dark btn-block"
                     @click="set_modulo('reimpresion')">
                     Re Impresión Facturas / Recibos
                  </button>
               </div>
               <div class="col-sm-12 mt-3">
                  <button type="button" class="btn btn-sm btn-outline-dark btn-block"
                     @click="set_modulo('certificacion_contingencia')">
                     Certificación Contingencia
                  </button>
               </div>

               <div class="col-sm-12 mt-3">
                  <button type="button" @click="set_modulo('solicitud_anulacion')"
                     class="btn btn-sm btn-outline-dark btn-block">
                     Solicitud de anulación
                  </button>
               </div>

               <div class="col-sm-12 mt-3 mb-3">
                  <button type="button" @click="set_modulo('anticipos')" class="btn btn-sm btn-outline-dark btn-block">
                     Anticipos
                  </button>
               </div>
            </b-row>
         </b-container>
      </div>

      <ReporteCorteCaja v-if="modulo == 'reporte_corte_caja'" v-on:salir="set_modulo('')" />
      <Reimpresion v-if="modulo == 'reimpresion'" v-on:salir="set_modulo('')" />
      <CertificacionContingencia v-if="modulo == 'certificacion_contingencia'" v-on:salir="set_modulo('')" />
      <SolicitudDeAnulacion v-if="modulo == 'solicitud_anulacion'" v-on:salir="set_modulo('')" />
      <Anticipos v-if="modulo == 'anticipos'" v-on:salir="set_modulo('')" />
   </div>
</template>

<script>
   import ReporteCorteCaja from "./Acciones/CorteCaja/Corte.vue";
   import Reimpresion from "./Acciones/ReImpresion/ReImpresion.vue";
   import CertificacionContingencia from "./Acciones/CertificacionContingencia/CertificacionContingencia.vue";
   import SolicitudDeAnulacion from './Acciones/SolicitudDeAnulacion/SolicitudAnulacion.vue'
   import Anticipos from './Acciones/Anticipos/Anticipos.vue'

   export default {
      name: "ModalMenuExtras",
      components: {
         ReporteCorteCaja,
         Reimpresion,
         CertificacionContingencia,
         SolicitudDeAnulacion,
         Anticipos
      },
      data() {
         return {
            modulo: "",
         };
      },
      methods: {
         cerrar() {
            this.$emit("salir");
         },
         set_modulo(modulo) {
            this.modulo = modulo;
         },
      },
   };
</script>

<style></style>
